import React from "react";
import { capitalise } from "@whitespace/whitespace-utils";

interface IFormValidation {
    fieldName: string;
    errors: any;
    validationFailures: any;
    prefix?: string;
}

export const ErrorMessages = ({ fieldName, errors, validationFailures, prefix } : IFormValidation) => {

    const capitalisedFieldName = capitalise(fieldName);
    const validationFieldName = prefix ? `${prefix}.${capitalisedFieldName}` : capitalisedFieldName;

    let content = null;
    if (errors && errors[fieldName]) {
        const testId = `validation-error-${fieldName}`;
        content = 
        <div role="alert" data-testid={testId} className="validation-error">
            {errors[fieldName].message}
        </div>;
    }
    else if (validationFailures && validationFailures[validationFieldName]) {
        content = validationFailures[validationFieldName].map((failure: any, index: any) => {
            return <div key={index} className="validation-error">{failure}</div>
        });
    }

    return (
        <>{content}</>
    );
}
